<template>
    <div @click="loginRedirect" :class="classes">
        <img :src="require(`../assets/twitch-logo.svg`)" class="login-img" />
        <span class="login-text"><slot></slot></span>
    </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'login-btn',
  props: {
    buttonClass: {
      type: String,
      default: 'login-btn'
    },
    buttonSelectedClass: {
      type: String,
      default: 'login-btn-selected'
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    loginUrl () {
      return Vue.config.CURRENCY_SERVICE_ROOT_BASE_URL + '/auth/login?path=' + encodeURIComponent(this.$route.path)
    },
    classes () {
      return {
        [this.buttonClass]: true,
        [this.buttonSelectedClass]: this.selected
      }
    }
  },
  methods: {
    loginRedirect () {
      window.location = this.loginUrl
    }
  }
}
</script>

<style scoped>
    .login-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background-color: var(--sl-purple);
      color: #fff;
      font-family: var(--sl-font);
      font-weight: 700;
      font-size: 14px;
      line-height: 1;
      padding: 10px 16px;
      border-radius: 8px;
      cursor: pointer;
      user-select: none;
      box-shadow: 0 6px 18px rgba(145, 70, 255, 0.35);
      transition: background-color 0.15s;
    }
    .login-btn:hover,
    .login-btn-selected {
      background-color: var(--sl-purple-hi);
    }
    .login-text {
      white-space: nowrap;
    }
    .login-img {
      width: 16px;
      height: 16px;
      display: block;
    }
    /* used by pages that pass buttonClass="btn-enabled" for a big in-page CTA */
    .btn-enabled .login-img,
    .btn-disabled .login-img {
      display: inline-block;
      width: 1em;
      height: 1em;
      vertical-align: -0.08em;
      margin-right: 0.4em;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login-Btn.vue